<!-- 上传单证 -->
 <template> 
    <div>
        <el-dialog title="随附单证编辑" :visible.sync="uploadShow" width="60%"  :close-on-click-modal="false" :before-close="uploadClose" >
            <el-form ref="uploadForm" :model="uploadForm" label-width="150px" size="mini">
                <el-form-item label="随附单证文件类别" v-if="isDeclareUpload?false:true">
                    <el-select class="width_100" filterable :default-first-option="true" v-model="uploadForm.fileType" placeholder="请选择随附单证文件类别">
                        <el-option v-for="item in autocompleterList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择随附单证文件">
                    <el-upload class="upload-demo" :action="fileUploadURL" :show-file-list="false" :file-list="fileList"
                    :before-upload="beforeUpload">
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">提示：发票只可上传后缀名为pdf的文件，单个文件大小不能超过4M，且每页不超过400K</div>
                    </el-upload>
                    <el-upload class="upload-demo" :action="batchFileUploadURL" :show-file-list="false" :file-list="batchfileList"
                     :on-success="batchSuccessUpload" multiple :headers="headers"  :data="{ interId: id }">
                        <el-button size="mini" type="success">批量上传</el-button>
                        <div slot="tip" class="el-upload__tip">提示：可批量上传报关资料，不限制格式</div>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="商品项号关系"></el-form-item> -->
                <!-- <el-form-item label="标记唛码附件"></el-form-item> -->
            </el-form>
            <el-table ref="uploadList" :data="uploadList" max-height="400px" :header-cell-style="{'text-align':'center'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column property="attachTypeText" label="类别" width="80" align="center"></el-table-column>
                <el-table-column property="" label="商品项号" width="120" align="center"></el-table-column>
                <el-table-column property="fileName" label="文件名称" width="200" align="center"></el-table-column>
                <el-table-column property="" label="单据编号" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" plain type="success" @click="downloadFile(scope.row)">下载</el-button>
                        <el-button size="mini" plain type="primary" @click="previewFile(scope.row)">预览</el-button>
                        <el-button size="mini" plain type="danger" @click="delFile(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="uploadClose()">关闭</el-button>
            </span>
        </el-dialog> 
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'
export default {
    props: {
        uploadShow: {
            type: Boolean,
            default: false
        },
        // 单据id
        id:{
            type: String,
            default: ''
        },
        // 是否是上传单据页面
        isDeclareUpload:{
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            autocompleterList:AEObasicData.autocompleterList, // 随附单据文件类别
            uploadForm:{
                fileType:'',
            }, // 上传单证表单
            uploadList:[],// 上传文件列表
            fileUploadURL:process.env.VUE_APP_BASE_API + 'cms/declare/uploadFile',
            batchFileUploadURL: process.env.VUE_APP_BASE_API + 'cms/declare/uploadDeclareFiles',
            batchfileList:[],
            fileList:[],
            headers:{ // 导入文件token
                'token': localStorage.getItem('token')
            }
        }
    },
    watch: {
        uploadShow:{
            handler(newVal,oldVal) { 
                if(newVal) {
                    this.getUploadFiles()
                }
            },
            deep: true,
            immediate: true
        },
        isDeclareUpload:{
             handler(newVal,oldVal) { 
                if(newVal) {
                    this.uploadForm.fileType = '报关单'
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() { 
    },
    methods: { 
        // 关闭上传
        uploadClose(){
            this.$emit('uploadClose')
        },
        beforeUpload(file){
            if(!this.uploadForm.fileType){
                this.$message({
                    message: '请先选择随附单证文件类别',
                    type: 'warning'
                });
                return false
            }
            // 如果是发票，只能传pdf
            if( this.uploadForm.fileType === '00000001' && file.type !== 'application/pdf'){
                this.$message({
                    message: '请上传pdf文件',
                    type: 'warning'
                });
                return false
            }
            // 判断大小不能超过4M
            if(this.uploadForm.fileType === '00000001' && file.size / 1024 / 1024 >= 4){
                this.$message({
                    message: '文件大小不能超过4M!',
                    type: 'warning'
                })
                return false
            }
            // if( file.size / 1024 / 1024 < 4){
                const formData = new FormData();
                formData.append('file', file);
                this.$api.uploadFile( this.id,this.uploadForm.fileType,formData ).then(res =>{
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    // 获取已上传的文件列表
                    this.getUploadFiles()
                })
            // }else{
            //     this.$message({
            //         message: '文件大小不能超过4M!',
            //         type: 'warning'
            //     });
            // }

            return false
        },
        // 批量上传成功
        batchSuccessUpload(response, file, fileList){
            // console.log(response, file, fileList)
            this.getUploadFiles()
        },
        getUploadFiles(){
            this.$api.declareGetFiles(this.id).then(res =>{
                this.uploadList = res
                this.uploadList.map(item =>{
                    item.attachTypeText = item.attachType === '报关单' || item.attachType === '报关资料' ? item.attachType : this.autocompleterList.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.attachType.toLowerCase()))[0].codeName
                    return {...item}
                })
            })
        },
        // 下载
        downloadFile(item){
            let a = document.createElement("a"); // 创建a标签
            a.style.display = "none";
            a.href = item.cosPath;
            a.setAttribute( "download", item.fileName ); // 给a标签设置download属性值，为从接口中获取到的需要下载的文件地址
            document.body.appendChild(a); // 将标签添加到页面
            a.click();
            document.body.removeChild(a);
        },
        // 预览
        previewFile(item){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: item.cosPath,
                    annexName: item.fileName,
                    id:item.id
                }
            }
            var childWindow = window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            var loop = setInterval(() => {
                if (childWindow.closed) {  // 检测子窗口是否关闭
                    clearInterval(loop); // 停止定时器
                    // 子窗口关闭后父页面刷新
                    // this.getTable()
                }
            }, 100);
        }, 
        // 删除
        delFile(item){
            this.$confirm('是否确认删除文件' +item.fileName, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteFile(item.id).then(res =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getUploadFiles()
                })
            }).catch(() => {
                         
            });
        }
    }
}
</script>
<style lang="css" scoped>
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
</style>